// extracted by mini-css-extract-plugin
export default {"root":"legal_data_root__v6G5C","link":"legal_data_link__FiSfH","paragraph":"legal_data_paragraph__UkAg+"};